var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-frontend',[_c('main',[_c('v-header',{attrs:{"country":_vm.country !== null ? _vm.country : ''}}),_c('v-search-shortcuts'),_c('v-tab')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }